// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../../../node_modules/rescript/lib/es6/list.js";
import * as $$Array from "../../../../../../../../node_modules/rescript/lib/es6/array.js";
import * as Curry from "../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Option from "../../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as PnMHelper$PorterinFeature from "../../../domain/helper/PnMHelper.mjs";

function PnmDropDownListCmp(Props) {
  var props = Props.props;
  var styles = Props.styles;
  return React.createElement("div", {
              className: styles["dropdown-list"] + " " + Belt_Option.getWithDefault(props.list.list_wrapper_class, "")
            }, $$Array.of_list(List.map((function (item) {
                        return React.createElement("div", {
                                    key: item,
                                    className: PnMHelper$PorterinFeature.selectInputItemStyles(item, styles, props.selection.selected_item),
                                    onClick: (function (param) {
                                        Curry._1(props.selection.on_item_selection, item);
                                      })
                                  }, item);
                      }), props.list.items_list)));
}

var make = PnmDropDownListCmp;

export {
  make ,
}
/* react Not a pure module */
